export const sharedLinksValidComponents = [
    "big_board",
    "conference_show_full",
    "customer_profile",
    "email_show",
    "live_dashboard",
    "message_show",
    "pulse_assessment_show",
    "scorecard_show",
    "ticket_show",
];

export const sharedLinksValidShareableTypes = [
    "account",
    "conference",
    "customer",
    "email",
    "message",
    "pulse_assessment",
    "scorecard",
    "ticket",
];